import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { SectionHelper, Text, TextButton } from '@wix/design-system';
import { useBiLogger } from '../../providers/BiLoggerProvider';
import { serializeRequestParams } from '../../utils';

export const SearchNotFound: React.FC<{ invoiceNumber: string }> = ({
  invoiceNumber,
}) => {
  const { biLogger } = useBiLogger();
  useEffect(() => {
    biLogger.chargeNotFoundView({ invoiceNumber });
  }, []);
  const params = {
    nodeId: '6254QgtObtQj40ReG5w6',
    referalInfo: 'unknown-charge',
    _invoiceNumber: invoiceNumber,
  };

  const logBI = () => {
    biLogger.notFoundClick({ invoiceNumber });
  };
  return (
    <SectionHelper appearance="preview">
      <Text size="small">
        <Trans i18nKey="charge-locator.results_page.section_helper.error.charge_not_found">
          charge-locator.results_page.section_helper.error
          <TextButton
            as="a"
            size="small"
            underline="always"
            skin="dark"
            target="_blank"
            onClick={logBI}
            href={`//www.wix.com/support-chatbot${serializeRequestParams(
              params,
            )}`}
          >
            charge_not_found
          </TextButton>
        </Trans>
      </Text>
    </SectionHelper>
  );
};
